import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SHEETS } from '../../ngrx/category-types';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const userData = localStorage.getItem('currentUser');
        const user = userData ? JSON.parse(userData) : null;

        if (!user) {
            this.router.navigate(['/pages/login'], { queryParams: { returnUrl: state.url }});
            return false;
        }

        // const { team } = user;

        // if (team === SHEETS) {
        //     return true;
        // } else {
        //     this.router.navigate(['/oa/dashboard/orders/all']);
        //     return false;
        // }

        return true;
    }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/guards/auth.guard.ts